import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { Col, Row, Button } from 'design-react-kit';
import moment from 'moment';
import { Error, NotFound } from '@plone/volto/components';

const messages = defineMessages({
  bookingFail: {
    id: 'booking_fail',
    defaultMessage: 'Prenotazione fallita',
  },
  bookingFailMessage: {
    id: 'booking_failMessage',
    defaultMessage:
      'La richiesta non è stata inviata correttamente, per favore riprovare più tardi.',
  },
  bookingUnauthorizedTitle: {
    id: 'booking_unauthorizedTitle',
    defaultMessage: 'Non sei autorizzato.',
  },
  bookingUnauthorizedMessage: {
    id: 'booking_unauthorizedMessage',
    defaultMessage: 'Non sei autorizzato ad accedere a questa prenotazione',
  },
  backToSlots: {
    id: 'booking_backToSlots',
    defaultMessage: 'Torna agli slot disponibili',
  },
});

const PrenotazioneFailed = ({
  error,
  setActiveStep,
  setBackToSlots,
  prenotazioneObj,
  setPrenotazioneObj,
  scrollToTop,
}) => {
  const intl = useIntl();
  moment.locale(intl.locale);
  const dateStart = moment();

  const errorResponse = error?.response ?? null;
  const errorCode = error?.status ?? '';
  const errorMessage =
    error?.response?.body?.error?.message ||
    error?.response?.body?.message ||
    intl.formatMessage(messages.bookingFailMessage);

  const goBackToSlots = () => {
    setPrenotazioneObj({
      ...prenotazioneObj,
      booking_month: {
        value: dateStart.format('YYYY-MM'),
        label: dateStart.format('MMMM'),
      },
      booking_date: null,
      currentPageDates: 1,
    });
    setActiveStep(1);
    setBackToSlots(true);
    scrollToTop();
  };

  if (errorCode === 401) {
    return <Error error={{ status: 401, message: 'Unauthorized' }} />;
  }

  if (errorCode === 404) {
    return <NotFound />;
  }

  const error_400_5xx =
    errorCode === 400 || (errorCode >= 500 && errorCode < 600);
  return (
    <div className="PageHeaderWrapper mb-4">
      <Row className="mb-2 mb-lg-0 page-header">
        <Col lg="8" className="pb-2 mx-4 page-header-left">
          {errorResponse && error_400_5xx && (
            <>
              <h1 className="d-flex align-items-center">
                <Icon className="me-2" color="danger" icon="it-close-circle" />
                {intl.formatMessage(messages.bookingFail)}
              </h1>
              <p className="documentDescription">{errorMessage}</p>
            </>
          )}

          {/* BOTTONE TORNA AGLI SLOT */}
          {error_400_5xx && (
            <Button
              color="primary"
              outline
              className="my-3 d-print-none"
              onClick={() => {
                goBackToSlots();
              }}
            >
              <Icon
                color="primary"
                className="me-2"
                size="sm"
                icon="it-calendar"
              />
              {intl.formatMessage(messages.backToSlots)}
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};

PrenotazioneFailed.propTypes = {
  error: PropTypes.object,
};

export default PrenotazioneFailed;
